import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { componentActions } from "../redux/slice";

import {
  selectArchiveComponentData,
  selectComponentFormData,
  selectPagination,
} from "../redux/selector";

import { actions as appActions } from "app/redux/slice";
import { ArchiveType } from "app/types";
import { IComponent } from "../types";

export const useComponentActions = ({projectId}: { projectId: string }) => {
  const dispatch = useDispatch();

  const formData = useSelector(selectComponentFormData);
  const archiveComponent = useSelector(selectArchiveComponentData);
  const pagination = useSelector(selectPagination);

  // ✅ ADD
  const handleAddComponent = useCallback(
    (callback?: () => void) => {
      if (!formData.name || !projectId) return;

      dispatch(componentActions.createComponent({ projectId, callback }));
    },
    [dispatch, formData.name, projectId],
  );

  // ✅ EDIT
  const handleEditComponent = useCallback(
    (callback?: () => void) => {
      if (!formData.name || !projectId) return;

      dispatch(componentActions.updateComponent({ projectId, callback }));
    },
    [dispatch, formData.name, projectId],
  );

  // ✅ OPEN ARCHIVE MODAL
  const handleArchiveClick = useCallback(
    (component: IComponent) => {
      dispatch(
        componentActions.setArchiveComponentData({
          _id: component._id,
          name: component.name,
        }),
      );
      dispatch(componentActions.setArchiveModalOpen(true));
    },
    [dispatch],
  );

  // ✅ CLOSE ARCHIVE MODAL
  const handleCloseArchiveModal = useCallback(() => {
    dispatch(componentActions.setArchiveComponentData(null));
    dispatch(componentActions.setArchiveModalOpen(false));
  }, [dispatch]);

  // ✅ TOGGLE ARCHIVE
  const handleToggleArchive = useCallback(() => {
    if (!archiveComponent?._id || !projectId) {
      handleCloseArchiveModal();
      return;
    }

    dispatch(
      appActions.doArchive({
        projectId,
        dataId: [archiveComponent._id],
        dataType: ArchiveType.COMPONENT,
        callback: () => {
          dispatch(
            componentActions.setPagination({
              ...pagination,
              page: 1,
            }),
          );
          dispatch(componentActions.fetchComponentsList({ projectId }));
          handleCloseArchiveModal();
        },
      }),
    );
  }, [
    dispatch,
    archiveComponent,
    projectId,
    pagination,
    handleCloseArchiveModal,
  ]);

  return {
    handleAddComponent,
    handleEditComponent,
    handleArchiveClick,
    handleCloseArchiveModal,
    handleToggleArchive,
  };
};
